export default __webpack_public_path__ + "static/media/ci.d14b72eb.svg";